<template>
  <div>
    <b-overlay :show="busy" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.saving") }}...
          </strong>
        </div>
        <div v-else-if="isLoading" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.loading") }}...
          </strong>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        ></div>
      </template>
    </b-overlay>

    <b-modal
      ref="show-location"
      size="xl"
      hide-footer
      :title="locals('inquiry.select_location')"
    >
      <div class="d-block text-center">
        <h3>{{ $t("leadcust.location_detail") }}</h3>
      </div>
      <b-row class="pt-2">
        <b-col md="3">
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="paginationLocation.perPage"
              :options="paginationLocation.perPageOptions"
              size="md"
            ></b-form-select>
          </b-form-group>
          <br />
        </b-col>
        <b-col md="6">
          <b-form-input
            id="i-search"
            class="input-sm"
            placeholder="Search"
            v-model="searchQuery"
            addon-right-icon="nc-icon nc-zoom-split"
          />
          <br />
        </b-col>
        <b-col md="3" class="text-right">
          <b-button
            style="margin-left: 5px"
            @click="onAddLocation('Recv', form.currentCustId)"
            size="md"
            variant="warning"
            :hidden="this.form.currentShowMode != 'Recv'"
          >
            {{ $t("inquiry.add_location_dest") }}
          </b-button>
          <b-button
            style="margin-left: 5px"
            @click="onAddLocation('Dest', form.currentCustId)"
            size="md"
            variant="warning"
            :hidden="this.form.currentShowMode != 'RowDest'"
          >
            {{ $t("inquiry.add_location_dest") }}
          </b-button>
          <br />
        </b-col>
        <b-col md="12">
          <b-table
            :fields="columns"
            :items="queriedDataLocation"
            striped
            responsive
          >
            <template #head(strAddrName)="">
              <div class="text-nowrap">{{ $t("leadcust.addrname") }}</div>
            </template>
            <template #head(strAddrDesc)="">
              <div class="text-nowrap">{{ $t("leadcust.addr") }}</div>
            </template>
            <template #head(strDistrict)="">
              <div class="text-nowrap">{{ $t("inquiry.district") }}</div>
            </template>
            <template #head(strSubDistrict)="">
              <div class="text-nowrap">{{ $t("inquiry.sub_district") }}</div>
            </template>
            <template #head(strProvince)="">
              <div class="text-nowrap">{{ $t("inquiry.city") }}</div>
            </template>
            <template #head(strPostcode)="">
              <div class="text-nowrap">{{ $t("inquiry.post_code") }}</div>
            </template>
            <template #head(strLocationMark)="">
              <div class="text-nowrap">{{ $t("leadcust.location_mark") }}</div>
            </template>
            <template #head(strLink)="">
              <div class="text-nowrap">Google Map Link</div>
            </template>
            <template #head(strContactName)="">
              <div class="text-nowrap">
                {{ $t("leadcust.maincontactname") }}
              </div>
            </template>
            <template #head(strTelNo)="">
              <div class="text-nowrap">{{ $t("leadcust.maintelno") }}</div>
            </template>
            <template #cell()="data">
              <div style="width: 100px">{{ data.value }}</div>
            </template>
            <template #cell(action)="data">
              <div class="text-center">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle"
                  @click="SelectLocation(data.index)"
                >
                  {{ $t("button.select") }}
                </b-button>
              </div>
            </template>
            <template #cell(strAddrName)="data">
              <div style="width: 200px">{{ data.value }}</div>
            </template>
            <template #cell(strAddrDesc)="data">
              <div style="width: 250px">{{ data.value }}</div>
            </template>
            <template #cell(strLink)="data">
              <div style="width: 500px">{{ data.value }}</div>
            </template>
          </b-table>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="paginationLocation.perPage"
              :options="paginationLocation.perPageOptions"
              size="md"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="pagination-info mt-2">
          <p class="category">
            Showing {{ fromLocation + 1 }} to {{ toLocation }} of
            {{ totalLocation }} entries
          </p>
        </b-col>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="paginationLocation.currentPage"
            :total-rows="paginationLocation.total"
            :per-page="paginationLocation.perPage"
            align="fill"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="hideModal2"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="show-contact"
      size="xl"
      hide-footer
      :title="locals('leadcust.contactname')"
    >
      <div class="d-block text-center">
        <h3>{{ $t("leadcust.contactname") }}</h3>
      </div>
      <b-row class="pt-2">
        <b-col md="3">
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="paginationContact.perPage"
              :options="paginationContact.perPageOptions"
              size="md"
            ></b-form-select>
          </b-form-group>
          <br />
        </b-col>
        <b-col md="6">
          <b-form-input
            id="i-search"
            class="input-sm"
            placeholder="Search"
            v-model="searchQueryContact"
            addon-right-icon="nc-icon nc-zoom-split"
          />
          <br />
        </b-col>
        <b-col md="3" class="text-right">
          <b-button
            style="margin-left: 5px"
            @click="onAddContact"
            variant="warning"
          >
             {{ $t("leadcust.addcontact") }}
          </b-button>
          <br />
          <br />
        </b-col>
        <b-col md="12">
          <b-table
            :fields="contactcolumns"
            :items="queriedDataContact"
            striped
            responsive
          >
            <template #head(strContactName)="">
              <div class="text-nowrap">
                {{ $t("leadcust.contactname") }}
              </div>
            </template>
            <template #head(strNickName)="">
              <div class="text-nowrap">
                {{ $t("leadcust.nickname") }}
              </div>
            </template>
            <template #head(strTelNo)="">
              <div class="text-nowrap">
                {{ $t("leadcust.telno") }}
              </div>
            </template>
            <template #head(strEmail)="">
              <div class="text-nowrap">
                {{ $t("leadcust.email") }}
              </div>
            </template>
            <template #head(strDepartment)="">
              <div class="text-nowrap">
                {{ $t("leadcust.department") }}
              </div>
            </template>
            <template #head(strPosition)="">
              <div class="text-nowrap">
                {{ $t("leadcust.position") }}
              </div>
            </template>
            <template #head(strRemark)="">
              <div class="text-nowrap">
                {{ $t("inquiry.remark") }}
              </div>
            </template>
            <template #cell(action)="data">
              <div class="text-center">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle"
                  @click="SelectContact(data.index)"
                >
                  {{ $t("button.select") }}
                </b-button>
              </div>
            </template>
          </b-table>
        </b-col>
        <b-col md="3">
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="paginationContact.perPage"
              :options="paginationContact.perPageOptions"
              size="md"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="pagination-info mt-2">
          <p class="category">
            Showing {{ fromContact + 1 }} to {{ toContact }} of
            {{ totalContact }} entries
          </p>
        </b-col>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="paginationContact.currentPage"
            :total-rows="paginationContact.total"
            :per-page="paginationContact.perPage"
            align="fill"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="hideModal3"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="add-location"
      size="lg"
      hide-footer
      :title="locals('inquiry.add_location')"
    >
      <div class="d-block text-center">
        <h3>{{ $t("leadcust.location_detail") }}</h3>
      </div>
      <b-row class="pt-1">
        <b-col md="12">
          <b-form-group
            label-for="i-main-addr"
            :label="locals('leadcust.addrname')"
            class="title-freight-require"
          >
            <b-form-input id="i-main-addr" v-model="listAddr.strAddrName" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <label for="i-note" class="title-freight-require">
            {{ locals("leadcust.addr") }}
            <span class="font-red">*</span>
          </label>
          <b-form-textarea
            id="i-addr"
            placeholder=""
            rows="2"
            v-model="listAddr.strAddrDesc"
            maxlength="500"
            @keydown.enter.prevent="showMessage"
          />
          <p v-if="enterPressed" class="text-danger pt-1">
            {{ locals("leadcust.error_msg1") }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="locals('inquiry.city')"
            label-for="i-province"
            class="title-freight-require pt-1"
          >
            <v-select
              v-model="listAddr.intProvinceId"
              :options="provinceOptions"
              :placeholder="locals('select.placeholder')"
              :reduce="(val) => val.intDsId"
              :clearable="true"
              @input="onChangeAddr(listAddr.intProvinceId, 'province')"
              label="strDsDesc"
              input-id="i-province"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="locals('inquiry.district')"
            label-for="i-district"
            class="title-freight-require pt-1"
          >
            <v-select
              v-model="listAddr.intDistrictId"
              :options="
                districtOptions.filter(
                  (b) => b.intRefId == listAddr.intProvinceId
                )
              "
              :placeholder="locals('select.placeholder')"
              :reduce="(val) => val.intDsId"
              @input="onChangeAddr(listAddr.intDistrictId, 'district')"
              label="strDsDesc"
              :clearable="true"
              input-id="i-district"
            >
              <template #option="{ strRefDesc, strDsDesc }">
                <h6 style="margin: 0">{{ strDsDesc }}</h6>
                <em>{{ strRefDesc }}</em>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="locals('inquiry.sub_district')"
            label-for="i-sub-district"
            class="title-freight-require"
          >
            <v-select
              v-model="listAddr.intSubDistrictId"
              :options="
                subdistrictOptions.filter(
                  (b) => b.intRefId == listAddr.intDistrictId
                )
              "
              :placeholder="locals('select.placeholder')"
              :reduce="(val) => val.intDsId"
              @input="onChangeAddr(listAddr.intSubDistrictId, 'subdistrict')"
              label="strDsDesc"
              :clearable="true"
              input-id="i-sub-district"
            >
              <template #option="{ strRefDesc, strDsDesc }">
                <h6 style="margin: 0">{{ strDsDesc }}</h6>
                <em>{{ strRefDesc }}</em>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="locals('inquiry.post_code')"
            label-for="i-postcode"
            class="title-freight-require"
          >
            <v-select
              v-model="listAddr.intPostcodeId"
              :options="
                postcodeOptions.filter(
                  (b) => b.intMainRefId == listAddr.intProvinceId
                )
              "
              :placeholder="locals('select.placeholder')"
              :reduce="(val) => val.intDsId"
              @input="onChangeAddr(listAddr.intPostcodeId, 'postcode')"
              label="strDsDesc"
              :clearable="true"
              input-id="i-postcode"
            >
              <template #option="{ strRefDesc, strDsDesc }">
                <h6 style="margin: 0">{{ strDsDesc }}</h6>
                <em>{{ strRefDesc }}</em>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group
            label-for="i-email"
            :label="locals('leadcust.email')"
            class="title-freight"
          >
            <b-form-input
              id="i-email"
              v-model="listAddr.strEmail"
              :class="{ 'is-invalid': !isEmailValid }"
              @input="validateEmail"
            />
            <b-form-invalid-feedback v-if="!isEmailValid">
              Please enter a valid email address.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="i-attach-file"
            :label="locals('inquiry.attached_file')"
            class="title-freight"
          >
            <b-form-file
              multiple
              accept=".pdf,.jpeg,.jpg,.png"
              :placeholder="locals('select.attach')"
              v-model="listAddr.strFile"
              @input="checkAndCompressListService('Addr', 1)"
            />
          </b-form-group>
          <span v-for="(obj, index) in listAddr.strFile">
            <span v-if="obj.strFilePath != '' && obj.strFilePath != null">
              <a href="#" @click="onView(obj)">
                <feather-icon
                  icon="DownloadIcon"
                  class="mr-50"
                  stroke="blue"
                  fill="blue"
                />
                {{ obj.name }}
              </a>
            </span>
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group
            label-for="i-link"
            label="Link Google Map"
            class="title-freight"
          >
            <b-form-input id="i-link" v-model="listAddr.strLink" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <label for="i-note" class="title-freight">{{
            locals("leadcust.location_mark")
          }}</label>
          <b-form-textarea
            id="i-location-mark"
            placeholder=""
            rows="2"
            v-model="listAddr.strLocationMark"
            maxlength="500"
            @keydown.enter.prevent="showMessage2"
          />
          <p v-if="enterPressed2" class="text-danger pt-1">
            {{ locals("leadcust.error_msg1") }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <div class="d-block pt-2">
            <h5 class="title-freight">{{ $t("leadcust.maincontactname") }}</h5>
          </div>
          <b-table
            :fields="contactcolumns2"
            :items="queriedData"
            striped
            responsive
          >
            <template #head(strContactName)="">
              <div class="text-nowrap">
                {{ $t("leadcust.contactname") }}
              </div>
            </template>
            <template #head(strNickName)="">
              <div class="text-nowrap">
                {{ $t("leadcust.nickname") }}
              </div>
            </template>
            <template #head(strTelNo)="">
              <div class="text-nowrap">
                {{ $t("leadcust.telno") }}
              </div>
            </template>
            <template #head(strEmail)="">
              <div class="text-nowrap">
                {{ $t("leadcust.email") }}
              </div>
            </template>
            <template #cell(action)="data">
              <div class="text-center">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle"
                  @click="SelectContact2(data.index)"
                >
                  {{ $t("button.select") }}
                </b-button>
              </div>
            </template>
          </b-table>
          <b-row>
            <!-- <b-col md="6" class="my-1">
              <b-form-group
                label="Per page"
                label-for="per-page-select"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-form-select
                  id="per-page-select"
                  v-model="pagination.perPage"
                  :options="pagination.perPageOptions"
                  size="sm"
                ></b-form-select>
              </b-form-group>
            </b-col> -->
            <b-col md="12" class="my-1">
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.total"
                :per-page="pagination.perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="i-contact"
            :label="locals('leadcust.maincontactname')"
            class="title-freight-require pt-1"
          >
            <b-form-input id="i-contact" v-model="listAddr.strContactName" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="i-telno"
            :label="locals('leadcust.maintelno')"
            class="title-freight-require pt-1"
          >
            <b-form-input
              id="i-telno"
              v-model="listAddr.strTelNo"
              type="number"
              :class="{ 'is-invalid': !isTelNoValid }"
              @input="validateTelNo"
            />
            <b-form-invalid-feedback v-if="!isTelNoValid">
              ❌ Please enter a valid telephone number. ❌
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1 btn-fixed-width"
            pill
            @click="onSaveLocation"
          >
            <font-awesome-icon icon="fa-solid fa-plus" />
            {{ $t("button.add") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="hideModal"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="add-contact"
      size="md"
      hide-footer
      :title="locals('leadcust.contactname')"
    >
      <div class="d-block text-center">
        <h3>{{ $t("leadcust.contactname") }}</h3>
      </div>
      <b-row class="pt-1">
        <b-col md="12">
          <b-form-group
            label-for="i-main-cust"
            :label="locals('inquiry.company_name')"
            class="title-freight"
          >
            <b-form-input
              id="i-main-contact"
              v-model="listAddr.strCustomerName"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="i-main-cust"
            :label="locals('leadcust.contactname')"
            class="title-freight-require"
          >
            <b-form-input id="i-main-cust" v-model="listAddr.strContactName" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="i-main-telno"
            :label="locals('leadcust.maintelno')"
            class="title-freight-require pt-1"
          >
            <b-form-input
              id="i-main-telno"
              v-model="listAddr.strTelNo"
              type="number"
              :class="{ 'is-invalid': !isTelNoValid }"
              @input="validateTelNo"
            />
            <b-form-invalid-feedback v-if="!isTelNoValid">
              ❌ Please enter a valid telephone number. ❌
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="i-main-email"
            :label="locals('leadcust.email') + ' (' + locals('leadcust.optional')+ ')'"
            class="title-freight"
          >
            <b-form-input
              id="i-main-email"
              v-model="listAddr.strEmail"
              :class="{ 'is-invalid': !isEmailValid }"
              @input="validateEmail(index)"
            />
            <b-form-invalid-feedback v-if="!isEmailValid">
              Please enter a valid email address.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="i-main-nickname"
            :label="locals('leadcust.nickname')+ ' (' + locals('leadcust.optional')+ ')'"
            class="title-freight"
          >
            <b-form-input id="i-main-nickname" v-model="listAddr.strNickName" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="i-main-department"
            :label="locals('leadcust.department') + ' (' + locals('leadcust.optional')+ ')'"
            class="title-freight"
          >
            <b-form-input
              id="i-main-department"
              v-model="listAddr.strDepartment"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="i-main-position"
            :label="locals('leadcust.position') + ' (' + locals('leadcust.optional')+ ')'"
            class="title-freight"
          >
            <b-form-input id="i-main-position" v-model="listAddr.strPosition" />
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1 btn-fixed-width"
            pill
            @click="onSaveContact"
          >
            <font-awesome-icon icon="fa-solid fa-plus" />
            {{ $t("button.add") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="hideModal4"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-card :title="locals('msg.detail')">
      <b-row>
        <b-col cols="12" class="mb-2">
          <b-row>
            <b-col md="3">
              <div class="d-sm-flex d-none user-nav">
                <p class="title-freight">Job No. :</p>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-sm-flex d-none user-nav">
                <p class="title-freight">{{ $t("inquiry.status") }} :</p>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-sm-flex d-none user-nav">
                <p class="title-freight">{{ $t("inquiry.create_by") }} :</p>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-sm-flex d-none user-nav">
                <p class="title-freight">{{ $t("inquiry.create_date") }} :</p>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-sm-flex d-none user-nav">
                <span class="leftpadding">
                  {{ showJobNo }}
                </span>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-sm-flex d-none user-nav">
                <span class="leftpadding">
                  {{ showStatus }}
                </span>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-sm-flex d-none user-nav">
                <span class="leftpadding">
                  {{ showBy }}
                </span>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-sm-flex d-none user-nav">
                <span class="leftpadding">
                  {{ showDate }}
                </span>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col md="3">
              <b-form-group
                class="title-freight-require"
                :label="locals('inquiry.customer_required_date')"
                label-for="loading-date"
              >
                <flat-pickr
                  v-model="form.datOrderDate"
                  button-only
                  class="form-control"
                  :config="{
                    enableTime: true,
                    dateFormat: 'd/m/Y H:i',
                  }"
                  :disabled="ifView"
              /></b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.customer_name')"
                label-for="i-customer"
                class="title-freight-require"
              >
                <v-select
                  id="i-customer"
                  v-model="form.intCustomerId"
                  :placeholder="locals('select.placeholder')"
                  label="strDsName"
                  :options="custOption"
                  :reduce="(val) => val.intDsId"
                  :disabled="ifView"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-request-type"
                class="title-freight-require"
                :label="locals('inquiry.type')"
              >
                <v-select
                  id="i-request-type"
                  input-id="i-request-type"
                  :clearable="true"
                  v-model="form.intJobTypeId"
                  label="title"
                  :options="job_type"
                  :reduce="(val) => val.Id"
                  :disabled="ifView"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-doc-type"
                class="title-freight-require"
                :label="locals('inquiry.doc_type')"
              >
                <v-select
                  id="i-doc-type"
                  input-id="i-doc-type"
                  :clearable="true"
                  v-model="form.intDocTypeId"
                  label="strDsDesc"
                  :options="doctypeOption"
                  :reduce="(val) => val.intDsId"
                  :disabled="ifView"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-fwd-no"
                label="Job No. (FWD)"
                class="title-freight"
              >
                <b-form-input
                  id="i-fwd-no"
                  v-model="form.strFWDNo"
                  placeholder="xxxxxxxxxxxx"
                  maxlength="30"
                  :disabled="ifView"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col md="3">
              <b-form-group
                :label="
                  locals('inquiry.partner_name') +
                  '-' +
                  locals('inquiry.pick_up_address')
                "
                label-for="i-recv-company"
                class="title-freight-require"
              >
                <v-select
                  id="i-recv-company"
                  v-model="form.intRecvBPId"
                  :placeholder="locals('select.placeholder')"
                  label="strDsName"
                  :options="custOption"
                  :reduce="(val) => val.intDsId"
                  :disabled="ifView"
                />
              </b-form-group>
            </b-col>
            <b-col md="9">
              <label
                for="i-recv"
                class="title-freight-require"
                style="padding-bottom: 5px"
              >
                {{ locals("inquiry.origin_port") }}
              </label>
              <b-button
                style="margin-left: 5px"
                @click="onViewLocation('Recv', form.intRecvBPId, 1)"
                size="sm"
                variant="outline-primary"
                :disabled="
                  form.intRecvBPId == '' || form.intRecvBPId == null || ifView
                "
              >
                {{ $t("inquiry.select_location") }}
              </b-button>
              <b-button
                style="margin-left: 5px"
                @click="onViewContact('Recv', form.intRecvBPId, 1)"
                size="sm"
                variant="outline-info"
                :disabled="
                  form.intRecvBPId == '' ||
                  form.intRecvBPId == null ||
                  ifView ||
                  form.strRecvLocation == ''
                "
              >
                 {{ $t("leadcust.selectcontact") }}
              </b-button>
              <!-- <b-button
                style="margin-left: 5px"
                @click="onAddLocation('Recv', form.intRecvBPId)"
                size="sm"
                variant="warning"
                :disabled="
                  form.intRecvBPId == '' || form.intRecvBPId == null || ifView
                "
              >
                {{ $t("inquiry.add_location_recv") }}
              </b-button> -->
              <b-form-textarea
                id="i-recv"
                :placeholder="locals('inquiry.unique_msg1')"
                rows="3"
                v-model="form.strRecvLocation"
                disabled
              />
              <b-button
                @click="onViewMap('Recv', 1)"
                size="sm"
                variant="outline-info"
                :disabled="form.strRecvLocation == ''"
              >
                {{ $t("inquiry.open_map") }}
              </b-button>
            </b-col>
          </b-row>
          <hr />
          <!--
          <b-row>
            <b-col md="3">
              <b-form-group
                :label="
                  locals('inquiry.partner_name') +
                  '-' +
                  locals('inquiry.delivery_address')
                "
                label-for="i-dest-company"
                class="title-freight-require"
              >
                <v-select
                  id="i-dest-company"
                  v-model="form.intDestBPId"
                  :placeholder="locals('select.placeholder')"
                  label="strDsName"
                  :options="custOption"
                  :reduce="(val) => val.intDsId"
                  :disabled="ifView"
                />
              </b-form-group>
            </b-col>
            <b-col md="9">
              <label
                for="i-dest"
                class="title-freight-require"
                style="padding-bottom: 5px"
              >
                {{ locals("inquiry.destination_port") }}
              </label>
              <b-button
                style="margin-left: 5px"
                @click="onViewLocation('Dest', form.intDestBPId, 1)"
                size="sm"
                variant="outline-primary"
                :disabled="
                  form.intDestBPId == '' || form.intDestBPId == null || ifView
                "
              >
                {{ $t("inquiry.select_location") }}
              </b-button>
              <b-button
                style="margin-left: 5px"
                @click="onAddLocation('Dest', form.intDestBPId)"
                size="sm"
                variant="warning"
                :disabled="
                  form.intDestBPId == '' || form.intDestBPId == null || ifView
                "
              >
                {{ $t("inquiry.add_location_dest") }}
              </b-button>
              <b-form-textarea
                id="i-dest"
                :placeholder="locals('inquiry.unique_msg1')"
                rows="3"
                v-model="form.strDestLocation"
                disabled
              />
              <b-button
                @click="onViewMap('Dest')"
                size="sm"
                variant="outline-info"
                :disabled="form.strDestLocation == ''"
              >
                {{ $t("inquiry.open_map") }}
              </b-button>
            </b-col>
          </b-row>
          -->
          <span v-for="(obj, index) in rowsdest">
            <b-row>
              <b-col md="12">
                <div class="d-block text-left">
                  <h6>
                    {{ $t("inquiry.delivery_address") }} : {{ index + 1 }}
                  </h6>
                </div>
                <div class="d-block text-right">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="btn-icon rounded-circle mr-1"
                    v-b-tooltip.hover.v-danger
                    title="Delete"
                    @click="onDelete(index)"
                    :hidden="ifView"
                  >
                    <font-awesome-icon icon="fa-solid fa-trash" />
                  </b-button>
                </div>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="
                    locals('inquiry.partner_name') +
                    '-' +
                    locals('inquiry.delivery_address')
                  "
                  label-for="i-dest-company"
                  class="title-freight-require"
                >
                  <v-select
                    id="i-dest-company"
                    v-model="rowsdest[index].intDestBPId"
                    :placeholder="locals('select.placeholder')"
                    label="strDsName"
                    :options="custOption"
                    :reduce="(val) => val.intDsId"
                    :disabled="ifView"
                  />
                </b-form-group>
              </b-col>
              <b-col md="9">
                <label
                  for="i-dest"
                  class="title-freight-require"
                  style="padding-bottom: 5px"
                >
                  {{ locals("inquiry.destination_port") }}
                </label>
                <b-button
                  style="margin-left: 5px"
                  @click="
                    onViewLocation(
                      'RowDest',
                      rowsdest[index].intDestBPId,
                      index
                    )
                  "
                  size="sm"
                  variant="outline-primary"
                  :disabled="
                    rowsdest[index].intDestBPId == '' ||
                    rowsdest[index].intDestBPId == null ||
                    ifView
                  "
                >
                  {{ $t("inquiry.select_location") }}
                </b-button>
                <b-button
                  style="margin-left: 5px"
                  @click="
                    onViewContact('RowDest', rowsdest[index].intDestBPId, index)
                  "
                  size="sm"
                  variant="outline-info"
                  :disabled="
                    rowsdest[index].intDestBPId == '' ||
                    rowsdest[index].intDestBPId == null ||
                    ifView ||
                    rowsdest[index].strDestLocation == ''
                  "
                >
                   {{ $t("leadcust.selectcontact") }}
                </b-button>
                <!-- <b-button
                  style="margin-left: 5px"
                  @click="onAddLocation('Dest', rowsdest[index].intDestBPId)"
                  size="sm"
                  variant="warning"
                  :disabled="
                    rowsdest[index].intDestBPId == '' ||
                    rowsdest[index].intDestBPId == null ||
                    ifView
                  "
                >
                  {{ $t("inquiry.add_location_dest") }}
                </b-button> -->
                <b-form-textarea
                  id="i-dest"
                  :placeholder="locals('inquiry.unique_msg1')"
                  rows="3"
                  v-model="rowsdest[index].strDestLocation"
                  disabled
                />
                <b-button
                  @click="onViewMap('Dest', index)"
                  size="sm"
                  variant="outline-info"
                  :disabled="rowsdest[index].strDestLocation == ''"
                >
                  {{ $t("inquiry.open_map") }}
                </b-button>
              </b-col>
            </b-row>
          </span>
          <b-row>
            <b-col md="12">
              <div class="d-flex justify-content-end">
                <b-button
                  v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                  variant="outline-info"
                  pill
                  @click="onAddDest"
                  :hidden="ifView"
                >
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">{{ $t("button.add_row") }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col md="12">
              <label for="textarea-default" class="title-freight">
                {{ $t("inquiry.job_detail") }} (*)
              </label>
              <b-form-textarea
                id="textarea-default"
                placeholder="ไปติดต่อ xxx แล้วรอรับกลับ"
                rows="3"
                v-model="form.strJobDetail"
                :disabled="ifView"
              />
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="12">
              <label for="textarea-remark" class="title-freight">
                {{ $t("inquiry.remark") }}
              </label>
              <b-form-textarea
                id="textarea-remark"
                placeholder="........................."
                rows="3"
                v-model="form.strRemark"
                :disabled="ifView"
              />
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col class="d-flex justify-content-center demo-inline-spacing">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mr-1 btn-fixed-width"
                pill
                @click="onSubmit('Submit')"
                :hidden="ifView"
              >
                <font-awesome-icon icon="fa-solid fa-check" />
                {{ $t("button.submit") }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="save"
                variant="outline-success"
                class="mr-1 btn-fixed-width"
                pill
                @click="onSubmit('Draft')"
                :hidden="ifView"
              >
                <font-awesome-icon icon="fa-solid fa-check" />
                {{ $t("button.draft") }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="submit"
                class="mr-1 btn-fixed-width"
                variant="outline-warning"
                pill
                @click="onBack"
              >
                {{ $t("button.back") }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseCheck from "@core/components/app-collapse/AppCollapseCheck.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import flatPickr from "vue-flatpickr-component";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

//npm install --save base64toblob
import base64toblob from "base64toblob";

import {
  BTable,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BFormCheckbox,
  BFormTextarea,
  BFormSelect,
  BPagination,
  BInputGroupPrepend,
  BFormFile,
  BTabs,
  BTab,
  BCardText,
  BModal,
  VBModal,
  BSpinner,
  BOverlay,
  VBTooltip,
} from "bootstrap-vue";

import Service from "@/@API/cDropdown";
import ReqService from "@/@API/cRequest";

export default {
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BTable,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    AppCollapse,
    AppCollapseItem,
    AppCollapseCheck,
    BFormRadio,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BFormCheckbox,
    BFormSelect,
    vSelect,
    flatPickr,
    BFormTextarea,
    VueGoodTable,
    BPagination,
    BInputGroupPrepend,
    BButton,
    BFormFile,
    Cleave,
    BTabs,
    BTab,
    BCardText,
    BModal,
    VBModal,
    BSpinner,
    BOverlay,
    VBTooltip,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      strInputStatus: "",
      strStatusShow: "",
      showJobNo: "",
      showStatus: "",
      showBy: "",
      showDate: "",
      busy: true,
      processing: false,
      isLoading: true,
      enterPressed: false,
      enterPressed2: false,
      isEmailValid: true,
      isTelNoValid: true,
      isSaving: false,
      isEdit: false,
      ifView: false,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      form: {},
      listAddr: {
        intDetailId: -1,
        intItemId: -1,
        intCustomerId: -1,
        strAddrName: "",
        strAddrDesc: "",
        strContactName: "",
        strTelNo: "",
        strEmail: "",
        strLink: "",
        intProvinceId: "",
        strProvince: "",
        intDistrictId: "",
        strDistrict: "",
        strDistrictETC: "",
        intSubDistrictId: "",
        strSubDistrict: "",
        strSubDistrictETC: "",
        intPostcodeId: "",
        strPostcode: "",
        strPostcodeETC: "",
        strRemark: "",
        strFile: null,
      },
      ori_province: [],
      provinceOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_district: [],
      districtOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_subdistrict: [],
      subdistrictOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_postcode: [],
      postcodeOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      custOption: [{ strDsName: "Loading...", intDsId: 1 }],
      TestOptions: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      job_type: [
        { title: "รับเอกสาร", Id: 1 },
        { title: "ส่งเอกสาร", Id: 2 },
      ],
      ori_doctype: [],
      doctypeOption: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: "Action",
          key: "action",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อสถานที่",
          key: "strAddrName",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ที่อยู่",
          key: "strAddrDesc",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "เขต",
          key: "strDistrict",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "แขวง",
          key: "strSubDistrict",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "จังหวัด",
          key: "strProvince",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "รหัสไปรษณีย์",
          key: "strPostcode",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "จุดสังเกต",
          key: "strLocationMark",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Google Map Link",
          key: "strLink",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้ติดต่อ",
          key: "strContactName",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "เบอร์โทรศัพท์",
          key: "strTelNo",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      rows: [],
      rowsdest: [
        {
          intItemId: 1,
          intDestBPId: "",
          strDestLocation: "",
          strDestLocationName: "",
          strDestAddrName: "",
          intDestSubDistrictId: "",
          strDestSubDistrict: "",
          intDestDistrictId: "",
          strDestDistrict: "",
          intDestProvinceId: "",
          strDestProvince: "",
          intDestPostCodeId: "",
          strDestPostCode: "",
          strDestGoogleMapLink: "",
          strDestLocationNote: "",
          strDestContactTelNo: "",
        },
      ],
      contactcolumns: [
        {
          label: "Action",
          key: "action",
          width: "100px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อผู้ติดต่อ",
          key: "strContactName",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อเล่น",
          key: "strNickName",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "เบอร์โทร",
          key: "strTelNo",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "อีเมลล์",
          key: "strEmail",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "หน่วยงาน",
          key: "strDepartment",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ตำแหน่ง",
          key: "strPosition",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      contactrows: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 15],
        total: 0,
      },
      contactrows2: [],
      contactcolumns2: [
        {
          label: "Action",
          key: "action",
          width: "100px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อผู้ติดต่อ",
          key: "strContactName",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อเล่น",
          key: "strNickName",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "เบอร์โทร",
          key: "strTelNo",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "อีเมลล์",
          key: "strEmail",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      searchQuery: "",
      paginationLocation: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 15],
        total: 0,
      },
      propsToSearch: [
        "strAddrName",
        "strAddrDesc",
        "strDistrict",
        "strSubDistrict",
        "strProvince",
        "strPostcode",
      ],
      searchQueryContact: "",
      paginationContact: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 15],
        total: 0,
      },
      propsToSearchContact: [
        "strContactName",
        "strNickName",
        "strTelNo",
        "strEmail",
        "strDepartment",
        "strPosition",
      ],
    };
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    pagedData() {
      return this.contactrows2.slice(this.from, this.to);
    },
    queriedData() {
      this.pagination.total = this.contactrows2.length;
      return this.pagedData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.contactrows2.length;
      return this.contactrows2.length;
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedDataLocation}
     */
    pagedDataLocation() {
      return this.rows.slice(this.fromLocation, this.toLocation);
    },
    queriedDataLocation() {
      if (!this.searchQuery) {
        this.paginationLocation.total = this.rows.length;
        return this.pagedDataLocation;
      }
      let result = this.rows.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          if (row[key] != null) {
            let rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(this.searchQuery)) {
              isIncluded = true;
            }
          }
        }
        return isIncluded;
      });
      this.paginationLocation.total = result.length;
      return result.slice(this.fromLocation, this.toLocation);
    },
    toLocation() {
      let highBound = this.fromLocation + this.paginationLocation.perPage;
      if (this.totalLocation < highBound) {
        highBound = this.totalLocation;
      }
      return highBound;
    },
    fromLocation() {
      return (
        this.paginationLocation.perPage *
        (this.paginationLocation.currentPage - 1)
      );
    },
    totalLocation() {
      this.paginationLocation.total = this.rows.length;
      return this.rows.length;
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedDataContact}
     */
    pagedDataContact() {
      return this.contactrows.slice(this.fromContact, this.toContact);
    },
    queriedDataContact() {
      if (!this.searchQueryContact) {
        this.paginationContact.total = this.contactrows.length;
        return this.pagedDataContact;
      }
      let result = this.contactrows.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearchContact) {
          if (row[key] != null) {
            let rowValue = row[key].toString();
            if (
              rowValue.includes &&
              rowValue.includes(this.searchQueryContact)
            ) {
              isIncluded = true;
            }
          }
        }
        return isIncluded;
      });
      this.paginationContact.total = result.length;
      return result.slice(this.fromContact, this.toContact);
    },
    toContact() {
      let highBound = this.fromContact + this.paginationContact.perPage;
      if (this.totalContact < highBound) {
        highBound = this.totalContact;
      }
      return highBound;
    },
    fromContact() {
      return (
        this.paginationContact.perPage *
        (this.paginationContact.currentPage - 1)
      );
    },
    totalContact() {
      this.paginationContact.total = this.contactrows.length;
      return this.contactrows.length;
    },
  },
  mounted() {
    let Id = localStorage.getItem("request-id");
    let StatusMode = localStorage.getItem("request-status");
    let lang = localStorage.getItem("language");

    this.busy = true;
    this.isLoading = true;
    //serviceOptions
    Service.getReqFormDropdown({})
      .then((response) => {
        console.log(response.data);
        let etcobj = {
          intDsId: 9999,
          strDsName: "ETC",
          strDsDesc: "ETC",
          intRefId: -1,
          strRefDesc: "ETC",
        };

        this.custOption = [];
        response.data.lstCustomer.forEach((cc) => {
          this.custOption.push(cc);
        });
        //console.log(response.data);
        //  ori_province provinceOptions ori_district districtOptions
        //  ori_subdistrict subdistrictOptions  ori_postcode postcodeOptions
        this.ori_province = [];
        response.data.lstProvince.forEach((e) => {
          this.ori_province.push(e);
        });
        let newlist15 = [];
        this.provinceOptions = [];
        newlist15 = this.ori_province.filter((a) => a.strLanguage == lang);
        newlist15.forEach((f) => {
          this.provinceOptions.push(f);
        });

        this.ori_district = [];
        response.data.lstDistrict.forEach((e) => {
          this.ori_district.push(e);
        });
        let newlist16 = [];
        this.districtOptions = [];
        newlist16 = this.ori_district.filter((a) => a.strLanguage == lang);
        newlist16.forEach((f) => {
          this.districtOptions.push(f);
        });
        this.districtOptions.push(etcobj);

        this.ori_subdistrict = [];
        response.data.lstSubDistrict.forEach((e) => {
          this.ori_subdistrict.push(e);
        });
        let newlist17 = [];
        this.subdistrictOptions = [];
        newlist17 = this.ori_subdistrict.filter((a) => a.strLanguage == lang);
        newlist17.forEach((f) => {
          this.subdistrictOptions.push(f);
        });
        this.subdistrictOptions.push(etcobj);

        this.ori_postcode = [];
        response.data.lstPostcode.forEach((e) => {
          this.ori_postcode.push(e);
        });
        let newlist18 = [];
        this.postcodeOptions = [];
        newlist18 = this.ori_postcode;
        newlist18.forEach((f) => {
          this.postcodeOptions.push(f);
        });
        this.postcodeOptions.push(etcobj);

        this.ori_doctype = [];
        response.data.lstReqForm.forEach((e) => {
          this.ori_doctype.push(e);
        });
        let newlist21 = [];
        this.doctypeOption = [];
        newlist21 = this.ori_doctype.filter((a) => a.strLanguage == lang);
        newlist21.forEach((f) => {
          this.doctypeOption.push(f);
        });

        this.busy = false;
        this.isLoading = false;
      })
      .catch((error) => {
        this.busy = false;
        this.isLoading = false;
      });
    ("-");
    // onClear();
    this.form = {
      intRequestId: -1,
      strRQMJobNo: "",
      strFWDNo: "",
      datOrderDate: "",
      intCustomerId: "",
      strCustomerName: "",
      intJobTypeId: "",
      strJobType: "รับเอกสาร",
      intDocTypeId: "",
      strDocType: "",
      strJobDetail: "",
      strJobNote: "",
      strStatus: "",
      strRemark: "",
      intRecvBPId: "",
      strRecvLocation: "",
      strRecvLocationName: "",
      strRecvAddrName: "",
      intRecvSubDistrictId: "",
      strRecvSubDistrict: "",
      intRecvDistrictId: "",
      strRecvDistrict: "",
      intRecvProvinceId: "",
      strRecvProvince: "",
      intRecvPostCodeId: "",
      strRecvPostCode: "",
      strRecvGoogleMapLink: "",
      strRecvLocationNote: "",
      strRecvContactTelNo: "",

      intDestBPId: "",
      strDestLocation: "",
      strDestLocationName: "",
      strDestAddrName: "",
      intDestSubDistrictId: "",
      strDestSubDistrict: "",
      intDestDistrictId: "",
      strDestDistrict: "",
      intDestProvinceId: "",
      strDestProvince: "",
      intDestPostCodeId: "",
      strDestPostCode: "",
      strDestGoogleMapLink: "",
      strDestLocationNote: "",
      strDestContactTelNo: "",
    };

    this.rowsdest = [];
    this.rowsdest = [
      {
        intItemId: 1,
        intDestBPId: "",
        strDestLocation: "",
        strDestLocationName: "",
        strDestAddrName: "",
        intDestSubDistrictId: "",
        strDestSubDistrict: "",
        intDestDistrictId: "",
        strDestDistrict: "",
        intDestProvinceId: "",
        strDestProvince: "",
        intDestPostCodeId: "",
        strDestPostCode: "",
        strDestGoogleMapLink: "",
        strDestLocationNote: "",
        strDestContactTelNo: "",
      },
    ];

    if (Id == -1) {
      var today = moment();
      today = today.format("DD/MM/YYYY");
      this.showDate = today;

      var new_date = moment().add(1, "days");
      new_date = new_date.format("DD/MM/YYYY");

      this.busy = false;
      this.isLoading = false;

      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "สร้างเอกสาร",
            icon: "PlusIcon",
            variant: "success",
            text: "สร้างเอกสารใหม่",
          },
        },
        {
          position: "top-center",
        }
      );
    } else {
      ReqService.getFormRequest({ intRequestId: Id })
        .then((response) => {
          this.form = response.data.headerGrid;
          this.isEdit = true;
          this.showJobNo = " ( " + this.form.strRQMJobNo + " ) ";
          this.showStatus = this.form.strStatus;
          this.showBy = this.form.strUpdatedBy;
          const uppdated = moment(this.form.datUpdatedDate).format(
            "DD/MM/YYYY HH:mm"
          );
          this.showDate = uppdated;

          this.form.datOrderDate = this.form.datOrderDate
            ? new Date(this.form.datOrderDate)
            : null;

          let recvtext = "";
          recvtext =
            this.form.strRecvLocationName +
            " " +
            this.form.strRecvAddrName +
            " " +
            this.form.strRecvSubDistrict +
            " " +
            this.form.strRecvDistrict +
            " " +
            this.form.strRecvProvince +
            " " +
            this.form.strRecvPostCode;
          if (
            this.form.strRecvLocationNote != "" &&
            this.form.strRecvLocationNote != null
          ) {
            recvtext = recvtext + " " + this.form.strRecvLocationNote;
          }
          recvtext = recvtext + " " + this.form.strRecvContactName;
          recvtext = recvtext + " " + this.form.strRecvContactTelNo;
          this.form.strRecvLocation = recvtext;

          let desttext = "";
          desttext =
            this.form.strDestLocationName +
            " " +
            this.form.strDestAddrName +
            " " +
            this.form.strDestSubDistrict +
            " " +
            this.form.strDestDistrict +
            " " +
            this.form.strDestProvince +
            " " +
            this.form.strDestPostCode;
          if (
            this.form.strDestLocationNote != "" &&
            this.form.strDestLocationNote != null
          ) {
            desttext = desttext + " " + this.form.strDestLocationNote;
          }
          desttext = desttext + " " + this.form.strDestContactName;
          desttext = desttext + " " + this.form.strDestContactTelNo;
          this.form.strDestLocation = desttext;

          this.rowsdest = response.data.destList;
          this.rowsdest.forEach((dat) => {
            let desttext = "";
            desttext =
              dat.strDestLocationName +
              " " +
              dat.strDestAddrName +
              " " +
              dat.strDestSubDistrict +
              " " +
              dat.strDestDistrict +
              " " +
              dat.strDestProvince +
              " " +
              dat.strDestPostCode;
            if (
              dat.strDestLocationNote != "" &&
              dat.strDestLocationNote != null
            ) {
              desttext = desttext + " " + dat.strDestLocationNote;
            }
            desttext = desttext + " " + dat.strDestContactName;
            desttext = desttext + " " + dat.strDestContactTelNo;
            dat.strDestLocation = desttext;
          });

          console.log("response.data", response.data);

          if (this.form.strStatus != "Draft" && this.form.strStatus != "ร่าง") {
            this.ifView = true;
          }

          //this.busy = false;
          //this.isLoading = false;

          if (StatusMode == "Edit") {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "แก้ไขเอกสาร",
                  icon: "EditIcon",
                  variant: "warning",
                  text: "แก้ไขเอกสาร : " + this.form.strRQMJobNo,
                },
              },
              {
                position: "top-center",
              }
            );
          }
          if (StatusMode == "Duplicate") {
            this.ifView = false;
            this.form.strStatus = "";

            this.showJobNo = "";
            this.showStatus = "";
            this.showBy = "";

            var today2 = moment();
            today2 = today2.format("DD/MM/YYYY");
            this.showDate = today2;

            this.form.intRequestId = -1;
            this.form.strRQMJobNo = "";
            this.form.strRQMJobNo = "";
            this.form.strStatus = "";
            this.form.datOrderDate = "";

            this.form.strFirstSubmitBy = null;
            this.form.datFirstSubmitDate = null;
            this.form.strLastSubmitBy = null;
            this.form.datLastSubmitDate = null;
            this.form.strFirstAcceptBy = null;
            this.form.datFirstAcceptDate = null;
            this.form.strLastAcceptBy = null;
            this.form.datLastAcceptDate = null;
            this.form.strFirstDeliveredBy = null;
            this.form.datFirstDeliveredDate = null;
            this.form.strLastDeliveredBy = null;
            this.form.datLastDeliveredDate = null;
            this.form.strFirstCompletedBy = null;
            this.form.datFirstCompletedDate = null;
            this.form.strLastCompletedBy = null;
            this.form.datLastCompletedDate = null;

            this.form.strCreatedBy = null;
            this.form.datCreatedDate = null;
            this.form.strUpdatedBy = null;
            this.form.datUpdatedDate = null;

            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "คัดลองเอกสาร",
                  icon: "CopyIcon",
                  variant: "success",
                  text: "คัดลองเอกสารแล้ว",
                },
              },
              {
                position: "top-center",
              }
            );
          }
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    }
  },
  methods: {
    validateTelNo() {
      const telPattern = /^[\d\s\-()]+$/;
      this.isTelNoValid = telPattern.test(this.listAddr.strTelNo);
    },
    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailValid = emailPattern.test(this.listAddr.strEmail);
    },
    showMessage() {
      this.enterPressed = true;
      setTimeout(() => {
        this.enterPressed = false;
      }, 3000);
    },
    showMessage2() {
      this.enterPressed2 = true;
      setTimeout(() => {
        this.enterPressed2 = false;
      }, 3000);
    },
    extractUniqueId(url) {
      const parts = url.split("/");
      return parts[parts.length - 1];
    },
    onViewMap(mode, index) {
      var googleMapUrl = "";
      if (mode == "Recv") {
        googleMapUrl = this.form.strRecvGoogleMapLink;
      } else {
        googleMapUrl = this.rowsdest[index].strDestGoogleMapLink;
      }
      window.open(googleMapUrl, "_blank");
    },
    onAddLocation(mode, intCustId) {
      this.enterPressed = false;
      this.resetModal();
      this.listAddr.strMode = mode;
      this.listAddr.intCustomerId = intCustId;
      this.onLoadContact(intCustId, "add");
      this.$refs["add-location"].show();
    },
    onAddContact() {
      this.enterPressed = false;
      this.resetModal();
      this.listAddr.intCustomerId = this.form.currentCustId;
      let currCust = this.custOption.find(
        (c) => c.intDsId === this.form.currentCustId
      );
      this.listAddr.strCustomerName = currCust.strDsName;
      this.$refs["add-contact"].show();
    },
    hideModal() {
      this.$refs["add-location"].hide();
    },
    hideModal4() {
      this.$refs["add-contact"].hide();
    },
    SelectLocation(index) {
      //let data = this.rows[index];
      let data = this.queriedDataLocation[index];
      if (this.form.currentShowMode == "Recv") {
        this.form.strRecvLocation = "";

        let recvtext = "";
        recvtext =
          data.strAddrName +
          " " +
          data.strAddrDesc +
          " " +
          data.strSubDistrict +
          " " +
          data.strDistrict +
          " " +
          data.strProvince +
          " " +
          data.strPostcode;
        if (data.strLocationMark != "" && data.strLocationMark != null) {
          recvtext = recvtext + " " + data.strLocationMark;
        }
        recvtext = recvtext + " // " + data.strContactName;
        recvtext = recvtext + " " + data.strTelNo;

        this.form.strRecvLocationName = data.strAddrName;
        this.form.strRecvAddrName = data.strAddrDesc;
        this.form.intRecvSubDistrictId = data.intSubDistrictId;
        this.form.strRecvSubDistrict = data.strSubDistrict;
        this.form.intRecvDistrictId = data.intDistrictId;
        this.form.strRecvDistrict = data.strDistrict;
        this.form.intRecvProvinceId = data.intProvinceId;
        this.form.strRecvProvince = data.strProvince;
        this.form.intRecvPostCodeId = data.intPostcodeId;
        this.form.strRecvPostCode = data.strPostcode;
        this.form.strRecvGoogleMapLink = data.strLink;
        this.form.strRecvLocationNote = data.strLocationMark;
        this.form.strRecvContactName = data.strContactName;
        this.form.strRecvContactTelNo = data.strTelNo;

        this.form.strRecvLocation = recvtext;
      } else if (this.form.currentShowMode == "Dest") {
        this.form.strDestLocation = "";
        let desttext = "";
        desttext =
          data.strAddrName +
          " " +
          data.strAddrDesc +
          " " +
          data.strSubDistrict +
          " " +
          data.strDistrict +
          " " +
          data.strProvince +
          " " +
          data.strPostcode;
        if (data.strLocationMark != "" && data.strLocationMark != null) {
          desttext = desttext + " " + data.strLocationMark;
        }
        desttext = desttext + " // " + data.strContactName;
        desttext = desttext + " " + data.strTelNo;

        this.form.strDestLocationName = data.strAddrName;
        this.form.strDestAddrName = data.strAddrDesc;
        this.form.intDestSubDistrictId = data.intSubDistrictId;
        this.form.strDestSubDistrict = data.strSubDistrict;
        this.form.intDestDistrictId = data.intDistrictId;
        this.form.strDestDistrict = data.strDistrict;
        this.form.intDestProvinceId = data.intProvinceId;
        this.form.strDestProvince = data.strProvince;
        this.form.intDestPostCodeId = data.intPostcodeId;
        this.form.strDestPostCode = data.strPostcode;
        this.form.strDestGoogleMapLink = data.strLink;
        this.form.strDestLocationNote = data.strLocationMark;
        this.form.strDestContactName = data.strContactName;
        this.form.strDestContactTelNo = data.strTelNo;

        this.form.strDestLocation = desttext;
      } else {
        //Mode RowDest
        this.rowsdest[this.form.RowIndex].strDestLocation = "";
        let desttext = "";
        desttext =
          data.strAddrName +
          " " +
          data.strAddrDesc +
          " " +
          data.strSubDistrict +
          " " +
          data.strDistrict +
          " " +
          data.strProvince +
          " " +
          data.strPostcode;
        if (data.strLocationMark != "" && data.strLocationMark != null) {
          desttext = desttext + " " + data.strLocationMark;
        }
        desttext = desttext + " // " + data.strContactName;
        desttext = desttext + " " + data.strTelNo;

        if (this.form.ifDest) {
          this.rowsdest[this.form.RowIndex].strDestLocationName =
            data.strAddrName;
          this.rowsdest[this.form.RowIndex].strDestAddrName = data.strAddrDesc;
          this.rowsdest[this.form.RowIndex].intDestSubDistrictId =
            data.intSubDistrictId;
          this.rowsdest[this.form.RowIndex].strDestSubDistrict =
            data.strSubDistrict;
          this.rowsdest[this.form.RowIndex].intDestDistrictId =
            data.intDistrictId;
          this.rowsdest[this.form.RowIndex].strDestDistrict = data.strDistrict;
          this.rowsdest[this.form.RowIndex].intDestProvinceId =
            data.intProvinceId;
          this.rowsdest[this.form.RowIndex].strDestProvince = data.strProvince;
          this.rowsdest[this.form.RowIndex].intDestPostCodeId =
            data.intPostcodeId;
          this.rowsdest[this.form.RowIndex].strDestPostCode = data.strPostcode;
          this.rowsdest[this.form.RowIndex].strDestGoogleMapLink = data.strLink;
          this.rowsdest[this.form.RowIndex].strDestLocationNote =
            data.strLocationMark;
          this.rowsdest[this.form.RowIndex].strDestContactName =
            data.strContactName;
          this.rowsdest[this.form.RowIndex].strDestContactTelNo = data.strTelNo;

          this.rowsdest[this.form.RowIndex].strDestLocation = desttext;
        }
      }
      this.hideModal2();
    },
    SelectContact(index) {
      let data = this.queriedDataContact[index];
      if (this.form.currentShowMode == "Recv") {
        this.form.strRecvLocation = "";
        let recvtext = "";
        recvtext =
          this.form.strRecvAddrName +
          " " +
          this.form.strRecvLocationName +
          " " +
          this.form.strRecvSubDistrict +
          " " +
          this.form.strRecvDistrict +
          " " +
          this.form.strRecvProvince +
          " " +
          this.form.strRecvPostCode;
        if (
          this.form.strRecvLocationNote != "" &&
          this.form.strRecvLocationNote != null
        ) {
          recvtext = recvtext + " " + this.form.strRecvLocationNote;
        }
        recvtext = recvtext + " // " + data.strContactName;
        recvtext = recvtext + " " + data.strTelNo;

        this.form.strRecvContactName = data.strContactName;
        this.form.strRecvContactTelNo = data.strTelNo;
 
        this.form.strRecvLocation = recvtext;
      } else if (this.form.currentShowMode == "Dest") {
        this.form.strDestLocation = "";
        let desttext = "";
        desttext =
          this.form.strDestAddrName +
          " " +
          this.form.strDestLocationName +
          " " +
          this.form.strDestSubDistrict +
          " " +
          this.form.strDestDistrict +
          " " +
          this.form.strDestProvince +
          " " +
          this.form.strPostcode;
        if (
          this.form.strDestLocationNote != "" &&
          this.form.strDestLocationNote != null
        ) {
          desttext = desttext + " " + this.form.strDestLocationNote;
        }
        desttext = desttext + " // " + data.strContactName;
        desttext = desttext + " " + data.strTelNo;

        this.form.strDestContactName = data.strContactName;
        this.form.strDestContactTelNo = data.strTelNo;

        this.form.strDestLocation = desttext;
      } else {
        //Mode RowDest
        this.rowsdest[this.form.RowIndex].strDestLocation = "";
        let desttext = "";
        desttext =
          this.rowsdest[this.form.RowIndex].strDestAddrName +
          " " +
          this.rowsdest[this.form.RowIndex].strDestLocationName +
          " " +
          this.rowsdest[this.form.RowIndex].strDestSubDistrict +
          " " +
          this.rowsdest[this.form.RowIndex].strDestDistrict +
          " " +
          this.rowsdest[this.form.RowIndex].strDestProvince +
          " " +
          this.rowsdest[this.form.RowIndex].strDestPostCode;
        if (
          this.rowsdest[this.form.RowIndex].strDestLocationNote != "" &&
          this.rowsdest[this.form.RowIndex].strDestLocationNote != null
        ) {
          desttext =
            desttext +
            " " +
            this.rowsdest[this.form.RowIndex].strDestLocationNote;
        }
        desttext = desttext + " // " + data.strContactName;
        desttext = desttext + " " + data.strTelNo;

        if (this.form.ifDest) {
          this.rowsdest[this.form.RowIndex].strDestContactName =
            data.strContactName;
          this.rowsdest[this.form.RowIndex].strDestContactTelNo = data.strTelNo;

          this.rowsdest[this.form.RowIndex].strDestLocation = desttext;
        }
      }
      this.hideModal3();
    },
    SelectContact2(index) {
      let data = this.queriedData[index];
      this.listAddr.strContactName = data.strContactName;
      this.listAddr.strTelNo = data.strTelNo;
    },
    onViewLocation(mode, intCustId, index) {
      this.onLoadLocation(intCustId);
      if (mode == "RowDest") {
        this.form.ifDest = true;
        this.form.RowIndex = index;
      } else {
        this.form.ifDest = false;
        this.form.RowIndex = 1;
      }
      this.searchQuery = "";
      this.$refs["show-location"].show();
      this.form.currentShowMode = mode;
      this.form.currentindex = index;
      this.form.currentCustId = intCustId;
    },
    onViewContact(mode, intCustId, index) {
      this.onLoadContact(intCustId, "load");
      if (mode == "RowDest") {
        this.form.ifDest = true;
        this.form.RowIndex = index;
      } else {
        this.form.ifDest = false;
        this.form.RowIndex = 1;
      }
      this.$refs["show-contact"].show();
      this.form.currentShowMode = mode;
      this.form.currentindex = index;
      this.form.currentCustId = intCustId;
    },
    onAddDest() {
      var obj = {
        intItemId: this.rowsdest.length + 1,
        intDestBPId: "",
        strDestLocation: "",
        strDestLocationName: "",
        strDestAddrName: "",
        intDestSubDistrictId: "",
        strDestSubDistrict: "",
        intDestDistrictId: "",
        strDestDistrict: "",
        intDestProvinceId: "",
        strDestProvince: "",
        intDestPostCodeId: "",
        strDestPostCode: "",
        strDestGoogleMapLink: "",
        strDestLocationNote: "",
        strDestContactTelNo: "",
      };
      this.rowsdest.push(obj);
    },
    onDelete(index) {
      this.rowsdest.splice(index, 1);
    },
    onLoadLocation(Id) {
      ReqService.getCustomerLocation({ intCustomerId: Id })
        .then((response) => {
          this.rows = response.data.addressList;
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onLoadContact(Id, mode) {
      ReqService.getCustomerContact({ intCustomerId: Id })
        .then((response) => {
          if (mode == "load") {
            this.contactrows = response.data.contactList;
          }
          if (mode == "add") {
            this.contactrows2 = response.data.contactList;
            this.pagination.total = this.contactrows2.length;
          }
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    hideModal2() {
      this.$refs["show-location"].hide();
    },
    hideModal3() {
      this.$refs["show-contact"].hide();
    },
    resetModal() {
      this.listAddr = {};
      this.listAddr = {
        intDetailId: -1,
        intItemId: -1,
        intCustomerId: -1,
        strAddrName: "",
        strAddrDesc: "",
        strTelNo: "",
        strEmail: "",
        strLink: "",
        intProvinceId: "",
        strProvince: "",
        intDistrictId: "",
        strDistrict: "",
        strDistrictETC: "",
        intSubDistrictId: "",
        strSubDistrict: "",
        strSubDistrictETC: "",
        intPostcodeId: "",
        strPostcode: "",
        strPostcodeETC: "",
        strRemark: "",
        strFile: null,
      };
    },
    onChangeAddr(inputid, mode) {
      if (inputid != "" && inputid != null) {
        if (mode == "province") {
          let currprovince = this.provinceOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr.strProvince = currprovince.strDsDesc;
          this.listAddr.intDistrictId = "";
          this.listAddr.strDistrict = "";
          this.listAddr.intSubDistrictId = "";
          this.listAddr.strSubDistrict = "";
          this.listAddr.intPostcodeId = "";
          this.listAddr.strPostcode = "";
        }
        if (mode == "district") {
          let currdistrict = this.districtOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr.strDistrict = currdistrict.strDsDesc;
          this.listAddr.intSubDistrictId = "";
          this.listAddr.strSubDistrict = "";
          this.listAddr.intPostcodeId = "";
          this.listAddr.strPostcode = "";
        }
        if (mode == "subdistrict") {
          let currsubdistrict = this.subdistrictOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr.strSubDistrict = currsubdistrict.strDsDesc;
        }
        if (mode == "postcode") {
          let currpostcode = this.postcodeOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr.strPostcode = currpostcode.strDsDesc;
        }
      }
    },
    tbuildFile(blob, name) {
      return new File([blob], name);
    },
    ttoBlob(imgUrl) {
      let blob = base64toblob(imgUrl.split(",")[1], "image/jpeg");
      let url = window.URL.createObjectURL(blob);
      return url;
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      var byteString = atob(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to an ArrayBuffer
      var arrayBuffer = new ArrayBuffer(byteString.length);
      var _ia = new Uint8Array(arrayBuffer);
      for (var i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
      }
      var dataView = new DataView(arrayBuffer);
      var blob = new Blob([dataView], { type: mimeString });
      return blob;
    },
    compressImage(mode, input, index, fileindex) {
      let file;

      if (mode == "Addr") {
        file = this.listAddr.strFile[fileindex];
      }

      let imageData = null;
      let context = null;
      let maxWidth = 2400;
      let maxHeigt = 2400;
      let width = maxWidth;
      let height = maxHeigt;
      let vm = this;

      let reader = new FileReader();
      let name = file.name;

      let img = new Image();
      var canvas = document.createElement("canvas");
      reader.onload = function (e) {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);

      img.onload = function () {
        // Draw
        context = canvas.getContext("2d");
        context.drawImage(img, 0, 0);

        if (img.width > maxWidth || img.height > maxHeigt) {
          width = maxWidth;
          height = maxHeigt;

          if (img.width > maxWidth) {
            width = maxWidth;
            var ration = maxWidth / img.width;
            height = Math.round(img.height * ration);
          }

          if (img.height > maxHeigt) {
            height = maxHeigt;
            var ration = maxHeigt / img.height;
            width = Math.round(img.width * ration);
          }
        } else {
          width = img.width;
          height = img.height;
        }
        canvas.width = width;
        canvas.height = height;

        context.drawImage(img, 0, 0, width, height);

        var objToPass = {};

        // Quality Of Image
        let quality = 100 / 100;
        imageData = canvas.toDataURL("image/jpeg", quality);
        imageData.replace("data:image/jpeg;base64,", "");
        let tblobToFile = vm.ttoBlob(imageData);
        let blobToFile = vm.dataURItoBlob(imageData);

        //console.log("imageData", imageData);
        //console.log(tblobToFile);
        //console.log(blobToFile);

        for (let qty = 100; blobToFile.size > 1048576 && qty > 0; ) {
          qty = qty - 10;
          quality = qty / 100;
          imageData = canvas.toDataURL("image/jpeg", quality);
          imageData.replace("data:image/jpeg;base64,", "");
          tblobToFile = vm.ttoBlob(imageData);
          blobToFile = vm.dataURItoBlob(imageData);
        }

        if (mode == "Addr") {
          vm.listAddr.strFile[fileindex] = vm.tbuildFile(imageData, name);
        }
      };
    },
    async checkAndCompressListService(mode, input) {
      if (mode == "Addr") {
        if (this.listAddr.strFile != null) {
          this.listAddr.strFile.forEach((file, fileindex) => {
            if (file.size > 1048576 && file.type.startsWith("image/")) {
              let filename = file.name;
              let title =
                "The file " +
                filename +
                " is larger than 1 MB. Do you want to compress it?";
              this.$bvModal
                .msgBoxConfirm(title, {
                  title: "Compress Image?",
                  size: "m",
                  modalClass: "modal-success",
                  okVariant: "success",
                  okTitle: "Compress",
                  cancelTitle: "Cancel",
                  cancelVariant: "outline-warning",
                  hideHeaderClose: false,
                  //centered: true,
                })
                .then((value) => {
                  if (value) {
                    this.compressImage(mode, 1, index, fileindex);
                  } else {
                    this.listAddr.strFile = null;
                  }
                });
            }
          });
        }
      }
    },
    onView(url) {
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:9090";
      window.open(
        `${baseUrl}api/v1/custview/Cust/${url.strFileName}`,
        "_blank"
      );
    },
    onSaveLocation() {
      let lang = localStorage.getItem("language");

      let ifcomp = true;
      let errorsmsg = "";
      errorsmsg = "";
      let ifcompdefault = true;
      if (
        this.listAddr.strAddrName == "" ||
        this.listAddr.strAddrName == null
      ) {
        ifcomp = false;
        ifcompdefault = false;
        if (lang == "th_TH") {
          errorsmsg = errorsmsg + " - กรุณาเลือก ";
        } else {
          errorsmsg = errorsmsg + " - Please Select ";
        }
        errorsmsg = errorsmsg + " Address Name , ";
      }
      if (
        this.listAddr.strAddrDesc == "" ||
        this.listAddr.strAddrDesc == null
      ) {
        ifcomp = false;
        if (ifcompdefault) {
          ifcompdefault = false;
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาเลือก ";
          } else {
            errorsmsg = errorsmsg + " - Please Select ";
          }
          errorsmsg = errorsmsg + " Address Detail , ";
        }
      }
      if (
        this.listAddr.strContactName == "" ||
        this.listAddr.strContactName == null
      ) {
        ifcomp = false;
        if (ifcompdefault) {
          ifcompdefault = false;
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาเลือก ";
          } else {
            errorsmsg = errorsmsg + "  - Please Select ";
          }
          errorsmsg = errorsmsg + " Contact Name , ";
        }
      }
      if (this.listAddr.strTelNo == "" || this.listAddr.strTelNo == null) {
        ifcomp = false;
        if (ifcompdefault) {
          ifcompdefault = false;
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาเลือก ";
          } else {
            errorsmsg = errorsmsg + "  - Please Select ";
          }
          errorsmsg = errorsmsg + " Tel No. , ";
        }
      }
      // if (this.listAddr.strEmail == "" || this.listAddr.strEmail == null) {
      //   ifcomp = false;
      //   if (ifcompdefault) {
      //     ifcompdefault = false;
      //     if (lang == "th_TH") {
      //       errorsmsg = errorsmsg + " - กรุณาเลือก ";
      //     } else {
      //       errorsmsg = errorsmsg + "  - Please Select ";
      //     }
      //     errorsmsg = errorsmsg + " Email , ";
      //   }
      // }
      if (
        this.listAddr.intProvinceId == "" ||
        this.listAddr.intProvinceId == null
      ) {
        ifcomp = false;
        if (ifcompdefault) {
          ifcompdefault = false;
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาเลือก ";
          } else {
            errorsmsg = errorsmsg + "  - Please Select ";
          }
          errorsmsg = errorsmsg + " Province , ";
        }
      }
      if (
        this.listAddr.intDistrictId == "" ||
        this.listAddr.intDistrictId == null
      ) {
        ifcomp = false;
        if (ifcompdefault) {
          ifcompdefault = false;
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาเลือก ";
          } else {
            errorsmsg = errorsmsg + "  - Please Select ";
          }
          errorsmsg = errorsmsg + " District , ";
        }
      }
      if (
        this.listAddr.intSubDistrictId == "" ||
        this.listAddr.intSubDistrictId == null
      ) {
        ifcomp = false;
        if (ifcompdefault) {
          ifcompdefault = false;
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาเลือก ";
          } else {
            errorsmsg = errorsmsg + "  - Please Select ";
          }
          errorsmsg = errorsmsg + " Sub-District , ";
        }
      }
      if (
        this.listAddr.intPostcodeId == "" ||
        this.listAddr.intPostcodeId == null
      ) {
        ifcomp = false;
        if (ifcompdefault) {
          ifcompdefault = false;
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาเลือก ";
          } else {
            errorsmsg = errorsmsg + "  - Please Select ";
          }
          errorsmsg = errorsmsg + " Post code , ";
        }
      }

      if (errorsmsg != "") {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "กรอกข้อมูลให้ครบถ้วน",
              icon: "AlertCircleIcon",
              variant: "danger",
              text: " Customer Details : " + errorsmsg,
            },
          },
          {
            position: "top-center",
            timeout: 10000,
          }
        );
      }
      if (!ifcomp) {
        return;
      }
      if (ifcomp) {
        this.busy = false;
        this.processing = false;
        //this.busy = true;
        this.strInputStatus = "Add";
        this.strStatusShow = "Confirm Add New Location";
        let b1 = "Add New";
        let b2 = "Cancel";

        if (lang == "th_TH") {
          b1 = "ยืนยัน";
          b2 = "ยกเลิก";
          this.strStatusShow = "ยืนยันการเพิ่มสถานที่";
        }

        this.$bvModal
          .msgBoxConfirm(this.strStatusShow, {
            title: this.strStatusShow,
            size: "sm",
            modalClass: "modal-success",
            okVariant: "success",
            okTitle: b1,
            cancelTitle: b2,
            cancelVariant: "outline-warning",
            hideHeaderClose: false,
            //centered: true,
          })
          .then((value) => {
            if (value) {
              this.onSubmitLocation();
            }
          });
      }
    },
    onSaveContact() {
      let lang = localStorage.getItem("language");

      let ifcomp = true;
      let errorsmsg = "";
      errorsmsg = "";
      let ifcompdefault = true;
      if (
        this.listAddr.strContactName == "" ||
        this.listAddr.strContactName == null
      ) {
        ifcomp = false;
        ifcompdefault = false;
        if (ifcompdefault) {
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาใส่ ";
          } else {
            errorsmsg = errorsmsg + "  - Please Fill In ";
          }
          errorsmsg = errorsmsg + " Contact Name , ";
        }
      }
      if (this.listAddr.strTelNo == "" || this.listAddr.strTelNo == null) {
        ifcomp = false;
        if (ifcompdefault) {
          ifcompdefault = false;
          if (lang == "th_TH") {
            errorsmsg = errorsmsg + " - กรุณาใส่ ";
          } else {
            errorsmsg = errorsmsg + "  - Please Fill In ";
          }
          errorsmsg = errorsmsg + " Tel No. , ";
        }
      }

      if (errorsmsg != "") {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "กรอกข้อมูลให้ครบถ้วน",
              icon: "AlertCircleIcon",
              variant: "danger",
              text: " Contact Details : " + errorsmsg,
            },
          },
          {
            position: "top-center",
            timeout: 10000,
          }
        );
      }
      if (!ifcomp) {
        return;
      }
      if (ifcomp) {
        this.busy = false;
        this.processing = false;
        //this.busy = true;
        this.strInputStatus = "Add";
        this.strStatusShow = "Confirm Add New Contact";
        let b1 = "Add New";
        let b2 = "Cancel";

        if (lang == "th_TH") {
          b1 = "ยืนยัน";
          b2 = "ยกเลิก";
          this.strStatusShow = "ยืนยันการเพิ่มรายชื่อผู้ติดต่อ";
        }

        this.$bvModal
          .msgBoxConfirm(this.strStatusShow, {
            title: this.strStatusShow,
            size: "sm",
            modalClass: "modal-success",
            okVariant: "success",
            okTitle: b1,
            cancelTitle: b2,
            cancelVariant: "outline-warning",
            hideHeaderClose: false,
            //centered: true,
          })
          .then((value) => {
            if (value) {
              this.onSubmitContact();
            }
          });
      }
    },
    onSubmitLocation() {
      let lang = localStorage.getItem("language");

      this.busy = true;
      this.processing = true;

      let confirm_addr_list = [];
      let confirm_addr_file = [];
      let confirm_addr_file_raw = [];
      let addrstartcountfile = 0;

      let startcountAddr = -2;
      if (
        this.listAddr.intDetailId == "" ||
        this.listAddr.intDetailId == null ||
        this.listAddr.intDetailId == -1
      ) {
        this.listAddr.intDetailId = startcountAddr;
        startcountAddr--;
      }
      confirm_addr_list.push(this.listAddr);
      // file
      if (this.listAddr.strFile != null) {
        this.listAddr.strFile.forEach((file, fileindex) => {
          let ffname = "Addr//" + file.name;
          let type = file.name.split(".");
          let intDId = -1;
          if (file.intDetailId != null) {
            intDId = file.intDetailId;
          }
          let fileobj = {
            intDetailId: intDId,
            intCustomerId: this.listData.intCustomerId,
            intAddrId: startcountAddr,
            intItemId: fileindex,
            intAllItemId: addrstartcountfile,
            intFileIndex: 1,
            strFileFromService: "Addr",
            strFreightFileName: file.name,
            strFileName: file.name,
            filesize: file.size,
            strFileType: file.type,
          };
          confirm_addr_file.push(fileobj);
          confirm_addr_file_raw.push(file);
          addrstartcountfile++;
        });
      }

      this.isSaving = true;
      var dataSave = {
        intCustomerId: this.listAddr.intCustomerId,
        addressList: confirm_addr_list,
        addrFile: confirm_addr_file,
      };
      console.log("dataSave", dataSave);

      let formData = new FormData();
      confirm_addr_file_raw.forEach((x) => {
        formData.append("files2", x);
      });
      formData.append("strJson", JSON.stringify(dataSave));

      ReqService.saveCustomerLocation(formData)
        .then((response) => {
          if (response.data == "ไม่พบรายชื่อลูกค้า") {
            this.busy = false;
            this.processing = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: response.data,
                },
              },
              {
                position: "top-center",
              }
            );
          } else {
            let compmsg = "Save Completed";
            if (lang == "th_TH") {
              compmsg = "บันทึกสำเร็จ";
            }
            this.busy = false;
            this.processing = false;
            this.isSaving = false;
            this.onLoadLocation(this.listAddr.intCustomerId);
            this.hideModal();
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: compmsg,
                  icon: "CheckIcon",
                  variant: "success",
                  text: response.data.message,
                },
              },
              {
                position: "top-center",
              }
            );
          }
        })
        .catch((error) => {
          this.busy = false;
          this.processing = false;
          this.isSaving = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onSubmitContact() {
      let lang = localStorage.getItem("language");

      this.busy = true;
      this.processing = true;

      let confirm_contact_list = [];
      let startcountAddr = -2;
      if (
        this.listAddr.intDetailId == "" ||
        this.listAddr.intDetailId == null ||
        this.listAddr.intDetailId == -1
      ) {
        this.listAddr.intDetailId = startcountAddr;
        startcountAddr--;
      }
      confirm_contact_list.push(this.listAddr);

      this.isSaving = true;
      var dataSave = {
        intCustomerId: this.listAddr.intCustomerId,
        contactList: confirm_contact_list,
      };
      console.log("dataSave", dataSave);

      let formData = new FormData();
      formData.append("strJson", JSON.stringify(dataSave));

      ReqService.saveCustomerContact(formData)
        .then((response) => {
          if (response.data == "ไม่พบรายชื่อลูกค้า") {
            this.busy = false;
            this.processing = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: response.data,
                },
              },
              {
                position: "top-center",
              }
            );
          } else {
            let compmsg = "Save Completed";
            if (lang == "th_TH") {
              compmsg = "บันทึกสำเร็จ";
            }
            this.busy = false;
            this.processing = false;
            this.isSaving = false;
            this.onLoadContact(this.form.currentCustId, "load");
            this.hideModal4();
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: compmsg,
                  icon: "CheckIcon",
                  variant: "success",
                  text: response.data.message,
                },
              },
              {
                position: "top-center",
              }
            );
          }
        })
        .catch((error) => {
          this.busy = false;
          this.processing = false;
          this.isSaving = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onSubmit(inputstatus) {
      let lang = localStorage.getItem("language");

      let ifcomp = true;
      let ifcomp2 = true;
      let errorsmsg = "";

      if (this.rowsdest.length <= 0) {
        ifcomp2 = false;
      } else {
        this.rowsdest.forEach((dat) => {
          if (dat.intDestBPId == null || dat.intDestBPId == "") {
            ifcomp2 = false;
          }
          if (dat.strDestLocation == null || dat.strDestLocation == "") {
            ifcomp2 = false;
          }
        });
      }

      if (
        !(
          this.form.datOrderDate == "" ||
          this.form.datOrderDate == null ||
          this.form.intCustomerId == null ||
          this.form.intCustomerId == "" ||
          this.form.intJobTypeId == null ||
          this.form.intJobTypeId == "" ||
          this.form.intDocTypeId == null ||
          this.form.intDocTypeId == "" ||
          this.form.strJobDetail == null ||
          this.form.strJobDetail == "" ||
          this.form.intRecvBPId == null ||
          this.form.intRecvBPId == "" ||
          this.form.strRecvLocation == null ||
          this.form.strRecvLocation == "" ||
          !ifcomp2
        )
      ) {
        if (this.form.intCustomerId != "" && this.form.intCustomerId != null) {
          let currCust = this.custOption.find(
            (c) => c.intDsId === this.form.intCustomerId
          );
          this.form.strCustomerName = currCust.strDsName;
        }

        if (this.form.intJobTypeId != "" && this.form.intJobTypeId != null) {
          let currjob = this.job_type.find(
            (j) => j.Id === this.form.intJobTypeId
          );
          this.form.strJobType = currjob.title;
        }

        if (this.form.intDocTypeId != "" && this.form.intDocTypeId != null) {
          let currdoc = this.doctypeOption.find(
            (d) => d.intDsId === this.form.intDocTypeId
          );
          this.form.strDocType = currdoc.strDsDesc;
        }

        if (this.form.intRecvBPId == null || this.form.intRecvBPId == "") {
          this.form.intRecvBPId = -1;
          this.form.strRecvLocationName = " ";
          this.form.strRecvAddrName = " ";

          this.form.intRecvSubDistrictId = -1;
          this.form.strRecvSubDistrict = " ";

          this.form.intRecvDistrictId = -1;
          this.form.strRecvDistrict = " ";

          this.form.intRecvProvinceId = -1;
          this.form.strRecvProvince = " ";

          this.form.intRecvPostCodeId = -1;
          this.form.strRecvPostCode = " ";

          this.form.strRecvGoogleMapLink = " ";
          this.form.strRecvLocationNote = " ";
          this.form.strRecvContactName = " ";
          this.form.strRecvContactTelNo = " ";
        }
        if (this.form.intDestBPId == null || this.form.intDestBPId == "") {
          this.form.intDestBPId = -1;
          this.form.strDestLocationName = " ";
          this.form.strDestAddrName = " ";

          this.form.intDestSubDistrictId = -1;
          this.form.strDestSubDistrict = " ";

          this.form.intDestDistrictId = -1;
          this.form.strDestDistrict = " ";

          this.form.intDestProvinceId = -1;
          this.form.strDestProvince = " ";

          this.form.intDestPostCodeId = -1;
          this.form.strDestPostCode = " ";

          this.form.strDestGoogleMapLink = " ";
          this.form.strDestLocationNote = " ";
          this.form.strDestContactName = " ";
          this.form.strDestContactTelNo = " ";
        }

        let StatusMode = localStorage.getItem("request-status");
        this.rowsdest.forEach((dat) => {
          if (StatusMode == "Duplicate") {
            dat.intUuId = -1;
            dat.intRequestId = -1;
          }
          if (dat.intDestBPId == null || dat.intDestBPId == "") {
            dat.strDestLocationName = " ";
            dat.strDestAddrName = " ";

            dat.intDestSubDistrictId = -1;
            dat.strDestSubDistrict = " ";

            dat.intDestDistrictId = -1;
            dat.strDestDistrict = " ";

            dat.intDestProvinceId = -1;
            dat.strDestProvince = " ";

            dat.intDestPostCodeId = -1;
            dat.strDestPostCode = " ";

            dat.strDestGoogleMapLink = " ";
            dat.strDestLocationNote = " ";
            dat.strDestContactName = " ";
            dat.strDestContactTelNo = " ";
          }
        });

        if (this.form.intRequestId == null || this.form.intRequestId == "") {
          this.form.intRequestId = -1;
        }

        if (this.form.strJobNote == null || this.form.strJobNote == "") {
          this.form.strJobNote = " ";
        }
        if (this.form.strRemark == null || this.form.strRemark == "") {
          this.form.strRemark = " ";
        }

        this.busy = false;
        this.processing = false;
        //this.busy = true;
        this.strInputStatus = inputstatus;
        this.strStatusShow = "Confirm " + inputstatus;
        let b1 = inputstatus;
        let b2 = "Cancel";

        if (lang == "th_TH") {
          b1 = "ยืนยัน";
          b2 = "ยกเลิก";
          if (inputstatus == "Submit") {
            this.strStatusShow = "ยืนยันการบันทึกข้อมูล";
          } else {
            this.strStatusShow = "ยืนยันการบันทึกร่าง";
          }
        }

        this.$bvModal
          .msgBoxConfirm(this.strStatusShow, {
            title: this.strStatusShow,
            size: "sm",
            modalClass: "modal-success",
            okVariant: "success",
            okTitle: b1,
            cancelTitle: b2,
            cancelVariant: "outline-warning",
            hideHeaderClose: false,
            //centered: true,
          })
          .then((value) => {
            if (value) {
              this.onSave();
            }
          });
      } else {
        let message = "";
        if (this.form.datOrderDate == "" || this.form.datOrderDate == null) {
          if (lang == "th_TH") {
            message = message + "- วันที่ต้องการ ,";
          } else {
            message = message + "- Require Sent Date ,";
          }
        }
        if (this.form.intCustomerId == null || this.form.intCustomerId == "") {
          if (lang == "th_TH") {
            message = message + "- ชื่อลูกค้า ,";
          } else {
            message = message + "- Customer Name ,";
          }
        }
        if (this.form.intJobTypeId == null || this.form.intJobTypeId == "") {
          if (lang == "th_TH") {
            message = message + " ประเภทงาน ";
          } else {
            message = message + " Job Type ";
          }
        }
        if (this.form.intDocTypeId == null || this.form.intDocTypeId == "") {
          if (lang == "th_TH") {
            message = message + " ประเภทเอกสาร ";
          } else {
            message = message + " Doc Type ";
          }
        }
        if (this.form.strJobDetail == null || this.form.strJobDetail == "") {
          if (lang == "th_TH") {
            message = message + " รายละเอียดงาน ";
          } else {
            message = message + " Job Detail ";
          }
        }
        if (
          this.form.intRecvBPId == null ||
          this.form.intRecvBPId == "" ||
          this.form.strRecvLocation == null ||
          this.form.strRecvLocation == ""
        ) {
          if (lang == "th_TH") {
            message = message + " รายละเอียดสถานที่รับเอกสาร";
          } else {
            message = message + " Pick-up Location Detail ";
          }
        }
        if (!ifcomp2) {
          if (this.rowsdest.length <= 0) {
            if (lang == "th_TH") {
              message = message + " สถานที่จัดส่งอย่างน้อย 1  ";
            } else {
              message = message + " At least 1 Delivery Location ";
            }
          } else {
            if (lang == "th_TH") {
              message = message + " รายละเอียดสถานที่จัดส่ง ";
            } else {
              message = message + " Destination Location Detail ";
            }
          }
        }

        let titlemsg = "Please Fill in below details ";
        let alertmsg = "Please Select ";
        if (lang == "th_TH") {
          alertmsg = "กรุณาเลือก";
          titlemsg = "กรอกข้อมูลให้ครบถ้วน ";
        }
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: titlemsg,
              icon: "AlertCircleIcon",
              variant: "danger",
              text: alertmsg + message,
            },
          },
          {
            position: "top-center",
            timeout: 10000,
          }
        );
      }
    },
    onSave() {
      let inputstatus = this.strInputStatus;
      let lang = localStorage.getItem("language");

      this.busy = true;
      this.processing = true;

      if (this.form.datOrderDate != "" && this.form.datOrderDate != null) {
        const OrderDate = moment(
          this.form.datOrderDate,
          "DD/MM/YYYY HH:mm"
        ).toDate();
        this.form.datOrderDate = OrderDate;
      }

      this.isSaving = true;
      var dataSave = {
        headerGrid: this.form,
        intRequestId: this.form.intRequestId,
        status: this.strInputStatus,
        destList: this.rowsdest,
      };
      console.log("dataSave", dataSave);

      let formData = new FormData();
      formData.append("strJson", JSON.stringify(dataSave));

      ReqService.saveRequest(formData)
        .then((response) => {
          if (response.data == "Error") {
            this.busy = false;
            this.processing = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: response.data,
                },
              },
              {
                position: "top-center",
              }
            );
          } else {
            this.$router.replace({ name: "request-search" }).then(() => {
              let compmsg = "Save Completed";
              if (lang == "th_TH") {
                compmsg = "บันทึกสำเร็จ";
              }
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: compmsg,
                    icon: "CheckIcon",
                    variant: "success",
                    text: response.data.message,
                  },
                },
                {
                  position: "top-center",
                }
              );
            });
          }
        })
        .catch((error) => {
          this.busy = false;
          this.processing = false;
          this.isSaving = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onBack() {
      this.$router.push({ name: "request-search" });
    },
    onchangeStringtoDouble(input) {
      let value;
      if (typeof input === "string") {
        value = Number.parseFloat(input.replaceAll(",", ""));
      } else if (typeof input === "string" && (input == "" || input == null)) {
        value = 0;
      } else {
        value = input;
      }
      return value;
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";

.font-red {
  color: red;
}

.is-invalid {
  border-color: red;
}

.map-responsive {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
}

.map-responsive iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
